import { RequestStatus } from "@/features/applications/model";
export const statusTransitions = {
    [RequestStatus.NEW]: [RequestStatus.DOCS_REQUIRED, RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.DOCS_REQUIRED]: [RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.READY_TO_SUBMIT]: [RequestStatus.SUBMITTED, RequestStatus.CANCELLED],
    [RequestStatus.SUBMITTED]: [RequestStatus.APPROVED, RequestStatus.REJECTED, RequestStatus.CANCELLED],
    [RequestStatus.APPROVED]: [RequestStatus.CANCELLED],
    [RequestStatus.REJECTED]: [RequestStatus.DOCS_REQUIRED, RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.CANCELLED]: [RequestStatus.NEW],
};
